'use client';
import { makeStyles, makeResetStyles, mergeClasses } from '@griffel/react';
import { createCustomFocusIndicatorStyle } from '@fluentui/react-tabster';
import { tokens } from '@fluentui/react-theme';
export const listItemClassNames = {
    root: 'fui-ListItem',
    media: 'fui-ListItem__media',
    header: 'fui-ListItem__header',
    contentWrapper: 'fui-ListItem__contentWrapper',
    headerMedia: 'fui-ListItem__headerMedia',
    contentMedia: 'fui-ListItem__contentMedia',
    endMedia: 'fui-ListItem__endMedia'
};
const useRootBaseStyles = makeResetStyles({
    padding: '0 10px',
    margin: 0,
    textIndent: 0,
    listStyleType: 'none',
    ...createCustomFocusIndicatorStyle({
        outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
        borderRadius: tokens.borderRadiusMedium
    }, {
        selector: 'focus'
    })
});
/**
 * Styles for the root slot
 */ const useStyles = makeStyles({
    contentWrapper: {
        fontSize: tokens.fontSizeBase200
    },
    // The content should go all the way to the end if the content media is not present
    contentWrapperWithoutMedia: {
        gridColumnEnd: 4
    },
    truncate: {
        overflow: 'hidden',
        textWrap: 'nowrap',
        textOverflow: 'ellipsis'
    },
    rootSelected: {
        backgroundColor: tokens.colorNeutralBackground1Selected
    },
    rootClickable: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: tokens.colorNeutralBackground1Hover
        }
    }
});
/**
 * Apply styling to the ListItem slots based on the state
 */ export const useListItemStyles_unstable = (state)=>{
    'use no memo';
    const rootBaseStyles = useRootBaseStyles();
    const styles = useStyles();
    state.root.className = mergeClasses(listItemClassNames.root, rootBaseStyles, (state.selectable || state.navigable) && styles.rootClickable, state.selected && styles.rootSelected, state.root.className);
    if (state.header) {
        var _state_header;
        state.header.className = mergeClasses(state.truncateHeader && styles.truncate, (_state_header = state.header) === null || _state_header === void 0 ? void 0 : _state_header.className);
    }
    if (state.contentWrapper) {
        var _state_contentWrapper;
        state.contentWrapper.className = mergeClasses(styles.contentWrapper, state.truncateContent && styles.truncate, !state.contentMedia && styles.contentWrapperWithoutMedia, (_state_contentWrapper = state.contentWrapper) === null || _state_contentWrapper === void 0 ? void 0 : _state_contentWrapper.className);
    }
    return state;
};
